// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const DQLSignetIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="DQLSignetIcon" ref={forwardedRef} {...props}>
      <path d="M5.47 11.698h.697c.735 0 1.096-.427 1.096-1.319V9.71q0-.53-.151-.861-.258-.567-.964-.566H5.47z" />
      <path d="M11.387 10.73V9.316c0-.7-.387-1.12-1.038-1.12S9.337 8.595 9.337 9.27v1.415c0 .688.387 1.102 1.038 1.102.65 0 1.012-.394 1.012-1.057" />
      <path d="M17 11.684a57 57 0 0 0-.12-3.156 67 67 0 0 0-.391-3.798l-.005-.033a.99.99 0 0 0-.81-.839 63 63 0 0 0-3.847-.578A54 54 0 0 0 8.64 3.003H8.625a1.6 1.6 0 0 0-1.21.452l-.266.25a2325 2325 0 0 0-3.642 3.419C2.983 7.628 2.998 8.459 3 8.547a73 73 0 0 0 .115 2.912 54 54 0 0 0 .394 3.803l.001.005a.986.986 0 0 0 .809.876h.004a57 57 0 0 0 3.859.584 61 61 0 0 0 1.944.179L11.433 17h.036a1.63 1.63 0 0 0 1.117-.45l.166-.157 1.037-.98c1.05-.991 2.356-2.225 2.695-2.542a1.55 1.55 0 0 0 .514-1.189zm-9.151-1.317c0 1.204-.6 1.854-1.701 1.854H4.897V7.76h1.27c1.09 0 1.682.681 1.682 1.937zm3.874 2.562-.948-.657a2 2 0 0 1-.425.045c-.967 0-1.599-.63-1.599-1.586V9.316c0-.994.645-1.65 1.625-1.65s1.598.637 1.598 1.605v1.415c0 .58-.226 1.044-.612 1.325l.703.453zm3.718-.708h-2.416V7.76h.586v3.925h1.83z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const DQLSignetIcon = /* @__PURE__ */ Object.assign(
  DQLSignetIconComponent,
  { displayName: 'DQLSignetIcon' },
);
